import React from 'react';
import { Col, Input, Row, Table } from 'reactstrap';
import catImg from '../../../../assets/images/dummyImages/cat-1.jpeg';

const SpecificProducts = () => {
    const transformedData = [
        { image: catImg, productName: 'Product 1', sku: 'SKU001', stock: '500', price: '10.00' },
        { image: catImg, productName: 'Product 2', sku: 'SKU002', stock: '500', price: '12.50' },
        { image: catImg, productName: 'Product 3', sku: 'SKU003', stock: '500', price: '8.00' },
        { image: catImg, productName: 'Product 4', sku: 'SKU004', stock: '500', price: '15.00' },
        { image: catImg, productName: 'Product 5', sku: 'SKU005', stock: '500', price: '20.00' },
        { image: catImg, productName: 'Product 6', sku: 'SKU006', stock: '500', price: '7.50' },
        { image: catImg, productName: 'Product 7', sku: 'SKU007', stock: '500', price: '18.00' },
        { image: catImg, productName: 'Product 8', sku: 'SKU008', stock: '500', price: '14.00' },
        { image: catImg, productName: 'Product 9', sku: 'SKU009', stock: '500', price: '9.99' },
        { image: catImg, productName: 'Product 10', sku: 'SKU010', stock: '500', price: '22.50' },
    ];

    return (
        <>
            <div>Coupon is applied to following products:</div>
            <div>
                <Row>
                    <Col xl='5' lg='5' md='5' sm='12' xs='12'>
                        <div 
                            disabled='true' 
                            color='primary' 
                            style={{ backgroundColor: '#FBBD34', borderRadius: 'none', minHeight: '38px', height: '100%', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                            <div>
                                Total Products: 10
                            </div>
                        </div>
                    </Col>
                    <Col xl='5' lg='5' md='5' sm='12' xs='12'>
                        <Input style={{ width: '100%' }} placeholder='Search' />
                    </Col>
                </Row>
                <div>
                    <div className="table-responsive">
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>SKU</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transformedData.map((row, index) => (
                                    <tr key={index}>
                                        <td style={{ maxHeight: '100px', overflowY: 'auto', display: 'block' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <img 
                                                        src={row.image} 
                                                        alt={row.productName} 
                                                        style={{ width: '53px', height: '50px', marginRight: '10px' }} 
                                                    />
                                                    <div style={{display:'flex', flexDirection:'column'}}>
                                                        <span>{row.productName}</span>
                                                        <span style={{ fontSize: '14px', color: '#555' }}>Stock: {row.stock}</span>
                                                        <span style={{ fontSize: '14px', color: '#555' }}>Price: $ {row.price}</span>

                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{row.sku}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SpecificProducts;
